import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

/**
 * Label + control + helper-text container shared by all leaf widgets.
 *
 * Der `[headerAction]`-Slot sitzt rechts in der Label-Zeile — dort landen feldbezogene Aktionen
 * (z.B. „Prompt verbessern" der KI-Anweisung), ohne dass ein Widget sein eigenes Label bauen muss.
 */
@Component({
  selector: 'sf-field-wrapper',
  standalone: true,
  host: {'class': 'block w-full'},
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex flex-col gap-1 w-full">
      @if (label || hasHeaderAction) {
        <div class="flex items-center justify-between gap-2">
          <label class="text-sm font-medium text-gray-900">{{ label }}</label>
          <ng-content select="[headerAction]"></ng-content>
        </div>
      }
      <ng-content></ng-content>
      @if (description) {
        <p class="text-xs text-gray-500 leading-tight">{{ description }}</p>
      }
    </div>
  `,
})
export class SfFieldWrapperComponent {
  @Input() label = '';
  @Input() description = '';
  /** True when the caller projects a header action — hält die Label-Zeile auch ohne Label am Leben. */
  @Input() hasHeaderAction = false;
}
